// extracted by mini-css-extract-plugin
export default {"noBackground":"Alert__noBackground___xv95W","notRounded":"Alert__notRounded___yhABW"};